export const environment = {
    production: true,
    environmentName: 'UAT',
    apiUrl: 'https://promoapp.posta.fo:6096',
    // dibsUrl: 'http://promo.posta.fo:20080'

    dibsUrl: 'https://promo.posta.fo:20080',
    beraUrl: 'https://promoapp.posta.fo:6096'

    // apiUrl: 'http://localhost:62411',
    // dibsUrl: 'http://localhost:20080'
  };
  